/**
 * Prompts a user when they exit the page
 */

import { useCallback, useContext, useEffect } from "react"
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom"

const useConfirmExit = (confirmExit, onConfirmCallBack, when = true) => {
  const { navigator } = useContext(NavigationContext)

  useEffect(() => {
    if (!when) return

    const push = navigator.push

    // Modify the push logic to allow for blocking the navigation
    navigator.push = (...args) => {
      const result = confirmExit()
      if (result !== false) {
        onConfirmCallBack()
        setTimeout(push(...args), 500)
      }
    }

    return () => {
      // Restore the initial logic of navigator.push
      navigator.push = push
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigator, confirmExit, when])
}

export const usePrompt = (message, when = true, onConfirmCallBack) => {
  const confirmExit = useCallback(() => window.confirm(message), [message])

  useEffect(() => {
    if (when) {
      window.onbeforeunload = () => message
    }

    return () => {
      window.onbeforeunload = null
    }
  }, [message, when])

  useConfirmExit(confirmExit, onConfirmCallBack, when)
}
